import {useEffect, useState} from 'react';
import axios from 'axios';

import  { motion } from 'framer-motion';

// Import Decorative Elements
import AboutPhoto from '../Decorations/Home/PNG/aboutlogo.png';
import AboutBorder from '../Decorations/Home/SVG/orangeaboutborder.svg';
import HomeBlackWave from '../Decorations/Home/SVG/HomeBlackWaveIntro2.svg';
import HomeLogo from '../Icons/HomeLogo.svg';
import HomeLogoText from '../Icons/HomeLogoText.svg'
import HomeLogoAnimated from '../Decorations/Home/HomeLogoAnimated';
import OrangeWave from '../Decorations/Home/SVG/HomeOrangeWaveIntro.svg';

export default function Home(){

    const [aboutPage, setaboutPage] = useState(0);


    return(
        <>
        <div className={'home-top-intro-div'}>

            {/* <img className={"home-background-svg"} src={HomeBlackWave}></img> */}
            <HomeLogoAnimated />

            <motion.img
            className={"home-logo-text"} 
            src={HomeLogoText}
                    initial={{
            opacity: 0,
            y: 20,
            width: "1.5vmin"
            }}

            animate={{
            opacity: 1,
            y:0,
            width: "37.5vmin"
            }}
            transition={{
            duration: 0.7,
            delay: 0.9,
            ease: "easeIn"
            }}
            >
            </motion.img>
            {/* <img className={"orange-wave"} src={OrangeWave}/> */}
             
        </div>

        <div className={"home-about-section"}>
            <img className={"about-border"} src={AboutBorder}></img>
            <img id={"about-pfp"} className={"about-photo"} src={AboutPhoto}>
            </img>
            <h2 id={"about-title"}>About Me</h2>
         
            <div className={"about-info"}>
                
                <br></br>
                <p>My name is Uziel Ohayon, and I am a multidisciplinary graphic designer specializing in illustration, branding, and photography.
                    I focus on developing cohesive visual identities and producing a wide range of design materials, including business cards, posters, banners, mock-ups, and leaflets. 
                </p>
                <p>In my practice, I also incorporate videography and advanced photo manipulation techniques to refine and elevate visual content. 
                My work is guided by clarity, precision, and strategic thinking, ensuring each project is professionally executed, visually engaging, 
                and tailored to effectively communicate across different audiences and platforms.
                </p>
                <br></br>
                <a id={"portfolio-link"} href={"/portfolio"}>Portfolio<span style={{"color": "orange", "marginLeft" : "5px"}}>.</span> <span style={{"color": "orange"}}>》</span></a>
            </div>

        </div>
        </>
    )
}